export abstract class TCommonModel {
  [key: string]: any;
}

export abstract class TListCommonModel {
  [key: string]: any;
}
